(() => {
  'use strict';
  if (customElements.get('ed-bingo-product')) return;
  customElements.define('ed-bingo-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.style.display = 'block';
      const $ = s => this.querySelector(s);
      const $$ = s => [...this.querySelectorAll(s)];
      const config = JSON.parse($('#ed-bingo-config').textContent);
      const t = config.strings;
      const audio = $('#demo-audio');
      const stopAudio = () => {
        audio.pause();
        audio.currentTime = 0;
        if ($('#play-label').textContent === t.stop) $('#play-label').textContent = t.listen_again;
        $('.play-symbol').textContent = '▶';
      };
      this.stopAudio = stopAudio;

      $$('.thumbs button').forEach(button => button.addEventListener('click', () => {
        $$('.thumbs button').forEach(b => {
          b.classList.toggle('selected', b === button);
          b.setAttribute('aria-pressed', String(b === button));
        });
        $('#hero-image').src = button.dataset.image;
        $('#hero-image').alt = button.dataset.alt;
        $('#zoom').setAttribute('aria-label', t.zoom.replace('__NAME__', button.dataset.alt));
        $('.gallery-caption').textContent = button.dataset.file === 'mockup-caja-retail-v4.webp' ? t.box_caption : button.dataset.file === 'muestra-jaguar.webp' ? t.card_caption : t.detail_caption;
      }));
      $('#zoom').addEventListener('click', () => {
        $('#zoom-image').src = $('#hero-image').src;
        $('#zoom-image').alt = $('#hero-image').alt;
        $('#image-dialog').showModal();
      });
      $('#image-dialog .close').addEventListener('click', () => $('#image-dialog').close());
      $('#image-dialog').addEventListener('click', event => {
        const dialog = $('#image-dialog');
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });

      const form = $('#ed-bingo-form');
      const quantity = $('#quantity');
      const currentVariant = () => config.variants.find(v => String(v.id) === form.elements.id.value) || config.variants[0];
      const updateQuantity = () => {
        const variant = currentVariant();
        const max = variant.max === null ? 999 : Math.max(1, variant.max);
        quantity.max = String(max);
        quantity.value = String(Math.min(max, Math.max(1, Number.parseInt(quantity.value, 10) || 1)));
        $('#minus').disabled = Number(quantity.value) <= 1;
        $('#plus').disabled = Number(quantity.value) >= max;
      };
      $('#minus').addEventListener('click', () => { quantity.value = Number(quantity.value) - 1; updateQuantity(); });
      $('#plus').addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; updateQuantity(); });
      quantity.addEventListener('change', updateQuantity);
      updateQuantity();
      $('#bingo-variant')?.addEventListener('change', () => {
        const variant = currentVariant();
        $$('[data-bingo-price]').forEach(el => { el.textContent = variant.price + (el.closest('#sticky-buy') ? ' ' + config.currency : ''); });
        $$('[data-add]').forEach(button => { button.disabled = !variant.available; });
        $$('[data-add]').forEach(button => { button.firstChild.textContent = variant.available ? t.add + ' ' : t.sold_out + ' '; });
        updateQuantity();
      });
      let submitting = false;
      form.addEventListener('submit', event => {
        if (submitting) { event.preventDefault(); return; }
        updateQuantity(); stopAudio(); submitting = true;
        $$('[data-add]').forEach(button => { button.setAttribute('aria-busy','true'); button.setAttribute('aria-disabled','true'); button.firstChild.textContent = t.adding + ' '; });
      });
      window.addEventListener('pageshow', () => {
        submitting = false;
        $$('[data-add]').forEach(button => { button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled'); button.firstChild.textContent = currentVariant().available ? t.add + ' ' : t.sold_out + ' '; });
      });
      $$('[data-add]').filter(button => !form.contains(button)).forEach(button => {
        button.addEventListener('click', () => form.requestSubmit(form.querySelector('[name="add"]')));
      });
      this.observers = [];
      if ('IntersectionObserver' in window) {
        const buyObserver = new IntersectionObserver(entries => { $('#sticky-buy').hidden = entries[0].isIntersecting; });
        buyObserver.observe($('.purchase'));
        this.observers.push(buyObserver);
      }

      $$('.audience-tabs button').forEach((button, i) => {
        button.addEventListener('click', () => {
          const mode = i === 0 ? 'home' : 'school';
          $$('.audience-tabs button').forEach(b => {
            b.setAttribute('aria-selected', String(b === button));
            b.tabIndex = b === button ? 0 : -1;
          });
          $('#audience-panel').setAttribute('aria-labelledby', button.id);
          $('#audience-panel h3').textContent = t[mode + '_title'];
          $('#audience-panel p').textContent = t[mode + '_text'];
        });
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const tabs = $$('.audience-tabs button');
          const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[1] : tabs[1-i];
          target.click();
          target.focus();
        });
      });

      const options = config.options;
      const order = [1,0,2];
      let round = 0, hasListened = false, completed = false;
      options.forEach(sound => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sound-choice';
        button.dataset.sound = sound.id;
        button.setAttribute('aria-label', t.choose.replace('__NAME__', sound.name));
        const picture = document.createElement('img');
        picture.className = 'demo-illustration';
        picture.src = sound.image;
        picture.alt = '';
        picture.width = 400;
        picture.height = 400;
        picture.loading = 'lazy';
        const label = document.createElement('span');
        label.textContent = sound.name;
        button.append(picture, label);
        button.addEventListener('click', () => {
          if (!hasListened) { $('#demo-feedback').textContent = t.start_listening; return; }
          if (completed) return;
          if (sound.id === options[order[round]].id) {
            completed = true;
            button.classList.add('correct');
            $('#demo-feedback').textContent = t.correct.replace('__ANSWER__', sound.answer);
            stopAudio();
          } else {
            button.classList.add('incorrect');
            $('#demo-feedback').textContent = t.try_again;
          }
        });
        $('#demo-options').appendChild(button);
      });
      const loadRound = () => {
        stopAudio();
        hasListened = completed = false;
        audio.src = options[order[round]].audio;
        $('#round').textContent = t.round.replace('__NUMBER__', String(round + 1));
        $('#play-label').textContent = t.listen;
        $('#demo-feedback').textContent = t.first_listen;
        $$('.sound-choice').forEach(button => button.classList.remove('correct','incorrect'));
      };
      $('#play-demo').addEventListener('click', async () => {
        if (!audio.paused) { stopAudio(); return; }
        try {
          await audio.play();
          hasListened = true;
          $('#play-label').textContent = t.stop;
          $('.play-symbol').textContent = '■';
          if (!completed) $('#demo-feedback').textContent = t.recognize;
        } catch { $('#demo-feedback').textContent = t.audio_error; }
      });
      audio.addEventListener('ended', () => { $('#play-label').textContent = t.listen_again; $('.play-symbol').textContent = '▶'; });
      $('#next-demo').addEventListener('click', () => { round = (round+1) % order.length; loadRound(); });
      loadRound();
      if ('IntersectionObserver' in window) {
        const audioObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting && !audio.paused) stopAudio(); });
        audioObserver.observe($('#pruebalo'));
        this.observers.push(audioObserver);
      }
      this.visibilityHandler = () => { if (document.hidden) stopAudio(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      window.addEventListener('pagehide', stopAudio);
    }
    disconnectedCallback() {
      this.stopAudio?.();
      this.observers?.forEach(observer => observer.disconnect());
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      window.removeEventListener('pagehide', this.stopAudio);
    }
  });
})();
